/* Keep the Senna livery controller in charge of the packaged photograph only.
 * The native sticky form still updates its price, product options, and buying state.
 */
(() => {
  const connect = (scope = document) => {
    scope.querySelectorAll('product-sticky-form[data-senna-livery-sticky]').forEach((form) => {
      if (form.dataset.sennaStickyMediaConnected === 'true') return;
      form.dataset.sennaStickyMediaConnected = 'true';
      form.updateProductMedia = (variant) => {
        form.dispatchEvent(new CustomEvent('senna:sticky-media-request', {
          bubbles: true,
          detail: { variant },
        }));
      };
    });
  };
  customElements.whenDefined('product-sticky-form').then(() => {
    connect();
    document.addEventListener('shopify:section:load', (event) => connect(event.target));
  });
})();
